import { MRT_ColumnDef } from 'material-react-table';
import { CustomAutocomplete, CustomTextField, EstadoComponente, TabTextLabel } from '@/shared/components/ui';
import { useFetchMotivosRechazo, useFetchOrdenesCompras, useGetOrdenesCompra, useUpdateOrdenesCompra } from '@/shared/actions/erp';
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering, useUploadFile } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { AlertSeverityEnum, MaterialTransferido, MotivoRechazo, } from '@/shared/interfaces';
import { Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useState } from 'react';
import { BucketAwtENUM, cellNotFilter, EstadosProcesoEnumChoice, formatDateWithTimeCell, gridSize, gridSizeMdLg4, gridSizeMdLg8, ROUTER_PATHS, TABLE_CONSTANTS, TABLE_CONSTANTS_COLUMS, texto } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import NoteAltIcon from '@mui/icons-material/NoteAlt';

import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useUiStore } from '@/store/ui';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import SampleTablePagination from '@/shared/components/ui/SampleTablePagination';
import CustomCantidadRecibidaInput from '@/shared/components/ui/CustomCantidadRecibidaInput';
import CargarDocumentoSoluccionCosteada from '@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada';
import ActionsBar from '@/shared/components/ui/ActionBar';
import { useFileDowloadDoc } from '@/shared/hooks/useDownloadFileDoc';
import { useFilePrint } from '@/shared/hooks/usePrintFile';
import { OrdenesCompra } from '@/shared/interfaces/erp/compras/ordenes-compra.interface';
import ModalObservacionNoForm from '@/shared/components/ui/ModalObservacionNoForm';
import ModalObservacionGeneral from '@/shared/components/ui/ModalObservacionesGeneral';
import EditIcon from '@mui/icons-material/Edit';


export default function SolicitudOrdenCompraEnesperaPagina() {
  //useCheckPermissions(PermissionsEnum.api_view_ordencompra);
  useCheckPermissionsArray([
    PermissionsEnum.api_change_ordencompra,
    PermissionsEnum.api_view_ordencompra
  ])
  //store
  //const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const setPaginationTableProducto = useCargarSeriesProductos(s => s.setPagination)
  const paginationTableProducto = useCargarSeriesProductos(s => s.pagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)

  ///state
  const [idEdit, /* setIdEdit */] = useState<string | null>(null);
  const [idEdit1, /* setIdEdit1 */] = useState<string | null>(null);
  const [observacionIngreso, /* setObservacionIngreso */] = useState<string>('')
  const [observacionOrdenCreador, /* setObservacionOrdenCreador */] = useState<string>('')
  const [archivo, setArchivo] = useState<File | null>(null)
  //console.log('obs', observacionOrdenCreador)
  const navigate = useNavigate();
  //const returnUrlOrdenesCompra = "/compras/orden-compras";
  const returnUrlOrdenesCompra = ROUTER_PATHS.compras.orden_compras_nav
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialogIsOpen2 = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [urlpdf, /* setUrlPdf */] = useState<string>('');
  const [total, /* setTotal */] = useState<number>()

  /*  useEffect(() => {
     console.log('productos', productos)
   }, [productos]) */

  const updateOrdenesCompra = useUpdateOrdenesCompra({
    navigate,
    returnUrl: returnUrlOrdenesCompra

  })
  const { data: dataOrdenCompra } = useGetOrdenesCompra(idEdit!)
  /// recuperar datos
  //const ordenCompras = useMaterialesUtilizadosStore(s => s.ordenesCompras);

  const { handleUploadFile } = useUploadFile()


  type SaveFormData = {
    motivo_rechazo: string;
    observaciones?: {
      observacionCreador?: string;
      observacionRevisor?: string;
    }
    cantidad_aprobada: number;
  }
  const form = useForm<SaveFormData>();

  const {
    control,
    formState: { errors },
  } = form;
  const { downloadFile } = useFileDowloadDoc()
  const { printFile } = useFilePrint()

  //funtion dowload
  const handleDowload = async () => {
    if (!urlpdf) return setAlert(true, 'No dispone ningun orden.', AlertSeverityEnum.info)

    downloadFile({
      url: urlpdf!,
      nameFile: "orden_compra",
      extensionFile: 'pdf'
    })
  };
  //funtion print
  const handlePrint = async () => {

    printFile({
      urlPdf: urlpdf!
    })
  }

  //***Precarga automaticamente en el campo cantidad aprobada el valor de cantidad
  /* const updateProductos = () => {
    if (!productos.length || productos.length === 0) return;
    const aux = productos.map((item)=>({
      ...item,
      cantidad_aprobada:Number(item.cantidad)
    }))
    handleCopiarLista(aux) */
  /* productos.forEach((item) => {
    const productosActualizado = {
      ...item,
      cantidad_aprobada: Number(item.cantidad)
    }
    handleActualizarProducto(item.id, productosActualizado);
  }) */
  /*   } */
  //***EJECUTA CUANDO ABRO EL MODAL */
  /*  useEffect(() => {
     if(!productos.length) return
     if (isModalOpen) {
       updateProductos()
     }
   }, [isModalOpen]) */

  //**************** MUTATION UPDATE
  const onSaveEdit = async () => {
    try {
      if (idEdit) {
        const campoInvalido = productos.find(item => item.cantidad_aprobada! <= 0)
        if (campoInvalido) {
          setAlert(true, `El producto "${campoInvalido.codigo}", tiene una cantidad aprobada inválida, debe ser mayor a cero.`, AlertSeverityEnum.error)
          return;
        }

        /*  const revisionOrden: any = {
            id: idEdit!,
            data: {
              estado_orden: EstadosProcesoEnumChoice.ABIERTO,
              detalles: productos,
              observaciones:{
                  observacionCreador: observacionOrdenCreador,
                  observacionRevisor: form.getValues().observaciones?.observacionRevisor
                }
              //detalles: ordenCompras
            },
          }
          console.log(revisionOrden)
          return;  */
        const isImage = archivo?.type.startsWith("image/")
        const bucketDestino = isImage
          ? BucketAwtENUM.IMAGE_REVISION_ORDEN
          : BucketAwtENUM.DOCUMENTO_REVISION_ORDEN_COMPRA
        const archivoRevision = (await handleUploadFile(archivo!, bucketDestino)).url;

        const urlsActual = dataOrdenCompra?.data?.urls_imagenes || {}
        updateOrdenesCompra.mutate(
          {
            id: idEdit!,
            data: {
              estado_orden: EstadosProcesoEnumChoice.ABIERTO,
              detalles: productos,
              observaciones: {
                observacionCreador: observacionOrdenCreador,
                observacionRevisor: form.getValues().observaciones?.observacionRevisor
              },
              urls_imagenes: {
                ...urlsActual,
                urlOrdenRevision: archivoRevision
              }
              //detalles: ordenCompras
            },
          },
          {
            onSuccess: () => {
              setIsModalOpen(false);
              clearSelectedItems()
              form.reset({ observaciones: { observacionRevisor: "" } })
              //form.reset({ observaciones: "" })
              refetch();
              setArchivo(null)
            },
            onError: (error: any) => {
              console.log("Error en la mutación", error)
            }
          }
        )

      } else {
        console.error("idEdit is null")
      }


    } catch (error) {
      console.error("Error en la mutación", error)
    }
  }
  //// funtion for cancel

  const handleConfirm = () => {
    if (form.getValues().motivo_rechazo === "") {
      setAlert(true, "Seleccione un motivo, para proceder con la confirmación.", "error")
      return;
    }
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro de que deseas Rechazar el orden de compra seleccionada?. Esta accción no se puede deshacer. ",
      title: "¡ Confirmación de Rechazo !",

      onConfirm: () => {
        try {
          setIsModalOpen2(true)

          if (idEdit1) {
            updateOrdenesCompra.mutate(
              {
                id: idEdit1!,
                data: {
                  estado_orden: EstadosProcesoEnumChoice.CANCELADO,
                  motivo_rechazo: form.getValues().motivo_rechazo,
                  observaciones: {
                    observacionCreador: observacionOrdenCreador,
                    observacionRevisor: form.getValues().observaciones?.observacionRevisor
                  },
                }
              },
              {
                onSuccess: () => {
                  setIsModalOpen(false);
                  setConfirmDialogIsOpen(false);
                  setIsModalOpen2(false);
                  form.reset({ motivo_rechazo: "" })
                  refetch()

                },
                onError: (error: any) => {
                  console.error("Error en la mutación", error)
                }
              }
            )
          } else {
            console.error("idEdit is mull")
          }
        } catch (error) {
          console.error("Error en la mutación")

        }

      },
      onClose() {
        setConfirmDialogIsOpen(false)
        setIsModalOpen(false)
        setConfirmDialogIsOpen2(false)
        setIsModalOpen2(false)
        refetch();
      },
    })
  }
  ///limpia el input de motivo
  useEffect(() => {
    if (!isModalOpen2) {
      form.setValue('motivo_rechazo', '')
    }
  }, [isModalOpen2, form.setValue])
  //alert 
  const setAlert = useUiStore((s) => s.setAlert);


  const columns = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(() => [
    {
      accessorKey: 'numero_referencia',
      header: 'numero referencia',
    },
    {
      accessorKey: 'concepto',
      header: 'concepto',
      size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      Cell: ({ row }) => {
        return (
          <ModalObservacionGeneral
            texto={
              row.original.concepto || 'N/A'
            }
            title="Motivo Compra"
            titleModal='Concepto'
          />
        )
      }
    },
    {
      accessorKey: 'plazo_pago',
      header: 'plazo pago',
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_orden',
      header: 'fecha orden',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_orden')
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_compra',
      header: 'fecha Compra',

      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_compra')
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_entrega',
      header: 'fecha entrega',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_entrega')
    },
    {
      accessorKey: 'forma_pago_data.nombre',
      header: 'forma_pago',
      Cell: ({ row }) => row.original?.forma_pago_data?.nombre || 'N/A'
    },
    {
      accessorKey: 'observaciones.observacionCreador',
      header: 'Observación del Generador Orden',
      size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      Cell: ({ row }) => (
        <ModalObservacionGeneral
          texto={row.original.observaciones?.observacionCreador || 'N/A'}
          title='Observación'
        />

      )

    },
    {
      accessorKey: 'solicitud_ingreso',
      header: 'solicitud ingreso',
      Cell: ({ row }) => row.original?.solicitud_ingreso || 'N/A'
    },
    {
      accessorKey: 'proveedor_data.razon_social',
      header: 'proveedor',
    },
    {
      accessorKey: "estado_solicitud",
      header: "estado",
      Cell: ({ row }) =>
        row.original.estado_orden != null ? (
          <EstadoComponente
            backgroundColor="#FFC107"
            texto={row.original?.estado_orden || ""}
          />
        ) : null,
    },
  ], []);

  /* const onDetails = (e: MRT_RowData) => {
    //console.log(e.total) 
    setTotal(e.total)
    setUrlPdf(e.url_pdf)
    setObservacionOrdenCreador(e.observaciones.observacionCreador)
    setObservacionIngreso(e?.solicitud_ingreso_data?.observaciones?.observacionSolicitante)
    const aux = e.detalles.map((item: MaterialTransferido) => ({
      ...item,
      cantidad_aprobada: Number(item.cantidad)
    }))
    handleCopiarLista(aux)
    //handleCopiarLista(e.detalles)
    setIdEdit(e.id_orden_compra)
    setIdEdit1(e.id_orden_compra)
    setIsModalOpen(true);
  }; */


  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] = useMemo<
    MRT_ColumnDef<MaterialTransferido>[]
  >(
    () => [
      {
        accessorKey: 'cantidad',
        header: 'Cantidad Requerida',
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. A Aprobar',
        Cell: ({ row }) => {
          const cantidadMaxima = Number(row.original.cantidad)
          return (
            <CustomCantidadRecibidaInput
              //value={Number(row.original.cantidad_aprobada) || 0}
              value={Number(row.original.cantidad) || 0}
              maxValue={cantidadMaxima}
              handleValue={(value) => {
                handleActualizarProducto(row.original.id, {
                  ...row.original,
                  cantidad_aprobada: value
                })
              }}
              row={row}
            />
          )
        }
      },
      {
        accessorKey: 'precio_compra',
        header: 'Precio Unitario',
        Cell: ({ row }) => {
          return `$${row.original?.precio_compra}`
        }
      },
      {
        accessorKey: 'precio_total',
        header: 'Precio Total',
        Cell: ({ row }) => {
          const value = row.original?.precio_total;
          return `$${Number(value).toFixed(3)}`
        }
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',
      },

      {
        accessorKey: 'stock_actual',
        header: 'Stock Actual',
        Cell: ({ row }) => row.original?.producto_data?.stock_actual ?? 'N/A',
      },
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },

      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Unidad Medida',
        Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
      },

    ],
    []
  );

  const {
    //globalFilter,
    pagination,
    searchTerm,
    //onChangeFilter,
    setPagination,
    //cleanFilter,

  } = useTableFilter();


  const { pageIndex, pageSize } = pagination;
  const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering();
  //normalizamos 
  const normalizeFilters = (filters: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.entries(filters).forEach(([key, value]) => {
      const cleanKey = key.includes('.') ? key.split('.').pop()! : key
      const mappedKey = cleanKey === 'razon_social' ? 'proveedor_razon_social' : cleanKey
      result[mappedKey] = value
    })
    return result
  }
  const { data: MotivoRechazoPaging, isLoading: isLoadingMotivoRechazo }
    = useFetchMotivosRechazo({ page_size: 600 })

  const { isLoading, data: solicitudPedidosEnesperaRes, isRefetching, refetch } = useFetchOrdenesCompras(
    {
      page: pageIndex + 1,
      concepto: searchTerm,
      estado_orden: EstadosProcesoEnumChoice.EN_ESPERA,
      page_size: pageSize,
      ...normalizeFilters(filterObject)
      //...filterObject,
      //filterByState: false,
    });
  /// el motivo de rechazo
  const onChangeMotivoRechazo = (value: string) => {
    form.setValue("motivo_rechazo", value)
  }



  useEffect(() => {
    return () => {
      clearSelectedItems()
    }
  }, [])

  return (

    <Grid container spacing={2}>

      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<OrdenesCompra>
          columns={columns}
          data={solicitudPedidosEnesperaRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosEnesperaRes?.data?.count}
          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          // // actions
          enableColumnActions={true}
          //actionsColumnSize={120}

          ///curd
          canDelete={false}
          positionActionsColumn="first"
          canEdit={false}
          enableEditing={true}

          //
          actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
          showCustomActionBtnSpace={true}
          customActionBtnSpace={(value) => {
            return (
              <>
                <Grid container>
                  <Grid item>
                    <Tooltip title={"Aprobar/ Rechazar"} placement='top'>
                      <IconButton
                        onClick={() => {
                          //onDetails(value)
                          navigate(`${ROUTER_PATHS.compras.orden_compras_revision.replace(':id', String(value.id_orden_compra))}`)
                        }}

                      >
                        <NoteAltIcon fontSize='medium' />
                      </IconButton>

                    </Tooltip>

                  </Grid>
                  <Grid item>
                    <Tooltip title={"editar"} placement='top'>
                      <IconButton
                        onClick={() => {
                          navigate(`${ROUTER_PATHS.compras.orden_compras_nav}/editar/${value.id_orden_compra}`)
                        }}
                      >
                        <EditIcon />
                      </IconButton>

                    </Tooltip>
                  </Grid>
                </Grid>
              </>
            )
          }}

        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Productos"
        confirmTextBtn='Aprobar'
        confirmBtnColor='success'
        confirmVariantBtn='contained'
        minWidth="80%"
        minHeight="96%"
        onConfirm={() => { onSaveEdit() }}
        onCloseIcon={() => { setIsModalOpen(false), form.setValue('observaciones.observacionRevisor', ''), clearSelectedItems() }}
        showConfirmBtn={true}
        showRejectBtn={true}
        rejectBtnColor='error'
        rejectVariantBtn={'outlined'}
        onReject={() => {
          setIsModalOpen2(true)
        }}

        contentNode={
          <>
            <Grid container spacing={3}>

              <Grid item {...gridSize}>
                <Grid container justifyContent={'flex-end'}>
                  <Grid item>
                    <ActionsBar
                      onDownload={handleDowload}
                      onPrint={handlePrint}
                    />

                  </Grid>

                </Grid>
              </Grid>
              {/*  <Grid item {...gridSize}>
                <Grid container justifyContent={'flex-end'}>
                  <Grid item>
                    <Typography>Total:{'cantidad'}</Typography>
                  </Grid>
                </Grid>

              </Grid> */}

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container justifyContent={'flex-end'}>
                  <Grid item>
                    <Typography variant='h6' fontWeight={'bold'}>MONTO TOTAL A PAGAR: {`$${total}`}</Typography>
                  </Grid>
                </Grid>

                <SampleTablePagination
                  columns={columnsProductosDetallePedidosDb}
                  data={paginatedData}
                  pagination={paginationTableProducto}
                  setPagination={setPaginationTableProducto}
                  rowCount={productos.length}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={3}>
              <Grid item {...gridSize}>
                <Paper className='paper-producto'>
                  <Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
                    {/* <CustomTextFieldNoForm
                      label="Observacion del solicitante"
                      value={observacionIngreso || 'N/A'}
                      size={gridSizeMdLg4}
                    /> */}
                    <ModalObservacionNoForm
                      label='Observación del Solicitante (Bodega)'
                      texto={observacionIngreso || 'N/A'}
                      title='Observación'
                      size={gridSizeMdLg4}
                      numbertextPreview={20}
                    />
                    <CustomTextField
                      label={texto.observacion}
                      name='observaciones.observacionRevisor'
                      control={form.control}
                      error={errors.observaciones?.observacionRevisor}
                      helperText={errors.observaciones?.observacionRevisor?.message}
                      required={false}
                      size={gridSizeMdLg8}
                    />

                    <Grid item xs={12}>
                      <TabTextLabel text={'Respaldo de aprobación'} mt={0} pb={0} pl={0} pt={2} />
                    </Grid>

                    <Grid item {...gridSizeMdLg4}>
                      <CargarDocumentoSoluccionCosteada
                        idInput='documento-solicitud_compra'
                        buttonText={'Respaldo de Aprobación'}
                        selectedImage={archivo}
                        setSelectedImage={setArchivo}
                        accept=".pdf, .png, .jpg, .jpeg"
                        tiposPermitidos={["application/pdf", "image/*"]}
                        permiteImagen={true}
                      />
                    </Grid>


                  </Grid>

                </Paper>

              </Grid>



            </Grid>

            {/* <Grid item {...gridSize}>
              <Paper className="Observaciones">
                <Grid container justifyContent={'space-between'} justifyItems={'center'}>
                  <CustomTextFieldNoForm
                    label="Observacion del solicitante"
                    value={'hola'}
                    size={gridSizeMdLg4}
                  />
                  <CustomTextFieldNoForm
                    label="Observacion del Supervisor"
                    value={'hola'}
                    size={gridSizeMdLg4}
                  />
                </Grid>

              </Paper>

            </Grid> */}


            {/* <Grid container xs={12}>
              <TextField
                variant='outlined'
                label="Observación"
                multiline
                rows={2}
                fullWidth
                {...form.register("observaciones")}
                error={!!errors.observaciones}
                helperText={errors.observaciones?.message}
              >
              </TextField>
            </Grid> */}
          </>
        }
      />
      <ScrollableDialogProps
        open={isModalOpen2}
        title="Rechazar el Orden"
        cancelTextBtn='Cancelar'
        confirmTextBtn='Rechazar'
        onCloseIcon={() => setIsModalOpen2(false)}
        showRejectBtn={true}
        rejectBtnColor='error'
        rejectVariantBtn='outlined'
        onReject={handleConfirm}
        contentNode={
          <>
            <CustomAutocomplete<MotivoRechazo>
              label="Motivo"
              name="motivo_rechazo"
              options={(MotivoRechazoPaging?.data.data as any)}
              valueKey='nombre'
              actualValueKey='codigo'
              defaultValue={form.getValues().motivo_rechazo || ''}
              isLoadingData={isLoadingMotivoRechazo}
              control={control}
              error={errors.motivo_rechazo}
              helperText={errors.motivo_rechazo?.message}
              onChangeValue={onChangeMotivoRechazo}
              optionLabelForEdit={
                MotivoRechazoPaging?.data.data.find((a) => a.codigo === form.getValues().motivo_rechazo)
                  ?.id_motivo_rechazo?.toString() || ""

              }
            />
          </>
        }
        onClose={() => { setIsModalOpen2(false) }}
      >
      </ScrollableDialogProps>
    </Grid>
  );
}

